<template>
  <div class="card-body">
    <h4 id="header-product-content" class="card-title card-collapse ">
      <span
        class="pointer"
        @click="
          productContentComponentModel.collapseState = !productContentComponentModel.collapseState
        "
        >Product Content</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="productContentComponentModel.validateState == false"
          @click="
            productContentComponentModel.collapseState = !productContentComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            productContentComponentModel.collapseState = !productContentComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="productContentComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-product-content"
      v-model="productContentComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <form @submit.prevent="onSubmit" @reset="onReset">
          <div class="pt-3">
            <div class="row">
              <div class="col-12">
                <div class="border-top pb-4"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card bg-dark-grey">
                  <div class="card-body f-12">
                    <div>คำแนะนำจุดขาย</div>
                    <ul class="mb-0">
                      <li>
                        สำหรับลง Catalog หรือ Monthly Mail และ
                        จุดขายในหน้ารายละเอียดสินค้า
                      </li>
                      <li>ความยาวไม่เกิน 450 ตัวอักษร</li>
                      <li>ขึ้นต้นด้วยชื่อสินค้าเสมอ</li>
                      <li>
                        เนื้อหาอธิบายถึงข้อดีของสินค้า
                        สินค้าช่วยให้ชีวิตของดีขึ้น หรือ ง่ายขึ้นได้อย่างไร
                        ช่วยแก้ปัญหาอะไรบ้าง
                      </li>
                      <li>ตรวจสอบการสะกดคำและการเว้นช่องว่างให้ถูกต้อง</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label mt-4"
                    for="shortDescriptionTH"
                    >จุดขาย</label
                  >
                  <div class="col-lg col-12">
                    <div class="text-center f-12 mb-2">ข้อมูลภาษาไทย</div>
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      name="shortDescriptionTH"
                      :rules="
                        is_free ? {} : { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                      "
                    >
                      <div class="input-group check-length">
                        <textarea
                          rows="4"
                          id="shortDescriptionTH"
                          name="shortDescriptionTH"
                          type="text"
                          class="form-control"
                          maxlength="450"
                          v-model="
                            productContentComponentModel.model.short_description
                              .th
                          "
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'content')
                              .isEditable === false
                          "
                        />

                        <span
                          v-if="
                            productContentComponentModel.model.short_description
                              .th
                          "
                          class="badge input-validate-length"
                          :class="{
                            'badge-success':
                              productContentComponentModel.model
                                .short_description.th.length !== 450,
                            'badge-danger':
                              productContentComponentModel.model
                                .short_description.th.length === 450,
                          }"
                          >{{
                            productContentComponentModel.model.short_description
                              .th.length
                          }}/450
                        </span>
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                  <div class="col-lg col-12">
                    <div class="text-center f-12 mb-2">
                      ข้อมูลภาษาอังกฤษ
                    </div>
                    <validationProvider
                      class="relative d-block form-group"
                      v-slot="{ errors }"
                      name="shortDescriptionEN"
                      :rules="
                        is_free ? {} : { dynamicRequired: ['กรุณาระบุข้อมูล'] }
                      "
                    >
                      <div class="input-group check-length">
                        <textarea
                          rows="4"
                          id="shortDescriptionEN"
                          name="shortDescriptionEN"
                          type="text"
                          class="form-control"
                          maxlength="450"
                          v-model="
                            productContentComponentModel.model.short_description
                              .en
                          "
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(f => f.name === 'content')
                              .isEditable === false
                          "
                        />
                        <span
                          v-if="
                            productContentComponentModel.model.short_description
                              .en
                          "
                          class="badge input-validate-length"
                          :class="{
                            'badge-success':
                              productContentComponentModel.model
                                .short_description.en.length !== 450,
                            'badge-danger':
                              productContentComponentModel.model
                                .short_description.en.length === 450,
                          }"
                          >{{
                            productContentComponentModel.model.short_description
                              .en.length
                          }}/450
                        </span>
                        <span v-if="errors.length" class="validate-invalid">
                          {{ errors[0] }}
                        </span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-row">
                  <label class="col-lg-4 col-xl-3 col-form-label" for="url"
                    >URL Spec สินค้าเพิ่มเติม หรือ Product Review</label
                  >
                  <div class="col-lg col-12">
                    <validationProvider
                      v-for="(url, index) in productContentComponentModel.model
                        .url"
                      :key="index"
                      class="relative d-block form-group inline-icon"
                      v-slot="{ errors }"
                      :name="`url_${index}`"
                    >
                      <input
                        name="url"
                        type="text"
                        class="form-control"
                        v-model="productContentComponentModel.model.url[index]"
                        :class="{ 'is-invalid': errors.length }"
                        :disabled="
                          dataPermissions.find(f => f.name === 'content')
                            .isEditable === false
                        "
                      />
                      <i
                        class="bx bx-trash icon-danger"
                        @click="onRemoveUrl(index)"
                        v-if="
                          dataPermissions.find(f => f.name === 'content')
                            .isEditable === true
                        "
                      ></i>
                      <span v-if="errors.length" class="validate-invalid">
                        {{ errors[0] }}
                      </span>
                    </validationProvider>
                    <button
                      type="button"
                      class="btn btn-light btn-sm"
                      @click="addURL()"
                      :disabled="
                        dataPermissions.find(f => f.name === 'content')
                          .isEditable === false
                      "
                    >
                      เพิ่ม URL
                      <i class="bx bx-plus-medical align-middle ml-1"></i>
                    </button>
                  </div>
                </div>
                <ProductContentEditComponent
                  v-model="productContentComponentModel.model.long_description"
                  :isEditable="
                    dataPermissions.find(f => f.name === 'content')
                      .isEditable === true
                  "
                >
                </ProductContentEditComponent>
                <!-- <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="shortDescriptionTH"
                    >คำอธิบายแบบยาว
                    <ButtonImportGetLink
                      v-if="
                        dataPermissions.find(f => f.name === 'content')
                          .isEditable === true
                      "
                      path="products/content"
                      contentDescription="pim-product-content"
                      maxSize="3248000"
                      maxHeight="0"
                      maxWidth="0"
                      acceptType=".jpg, .jpeg, .png"
                      title="สร้าง URL จากรูปที่นำเข้า"
                      :isUpsert="true"
                      :isPopupModal="true"
                    />
                  </label>
                  <div class="col">
                    <tinymce
                      class="relative d-block form-group"
                      id="longDescriptionTH"
                      v-model="
                        productContentComponentModel.model.long_description.th
                      "
                      :plugins="plugins"
                      :toolbar="toolbar"
                      :other_options="options"
                      :readonly="
                        dataPermissions.find(f => f.name === 'content')
                          .isEditable === false
                      "
                    ></tinymce>
                  </div>
                  <div class="col">
                    <tinymce
                      class="relative d-block form-group"
                      id="longDescriptionEN"
                      v-model="
                        productContentComponentModel.model.long_description.en
                      "
                      :plugins="plugins"
                      :toolbar="toolbar"
                      :other_options="options"
                      :readonly="
                        dataPermissions.find(f => f.name === 'content')
                          .isEditable === false
                      "
                    ></tinymce>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </form>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import ProductContentEditComponent from '../../share/product-content-edit-component.vue'
import { eventBus } from '@/main.js'
// import ButtonImportGetLink from '@/components/share/button-import-get-link'
// import tinymce from 'vue-tinymce-editor'

export default {
  name: 'Content',
  components: {
    // ButtonImportGetLink,
    // tinymce,
    ProductContentEditComponent,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.productContentComponentModel
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      // Tinymce Editor
      plugins: [
        'advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
        'save table contextmenu directionality emoticons template paste textcolor',
      ],
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons',
      options: {
        height: 200,
        style_formats: [
          { title: 'Bold text', inline: 'b' },
          { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
          { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
          { title: 'Example 1', inline: 'span', classes: 'example1' },
          { title: 'Example 2', inline: 'span', classes: 'example2' },
          { title: 'Table styles' },
          { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
        ],
      },
      urlCount: 1,
      productContentComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          short_description: { en: '', th: '' },
          long_description: { en: '', th: '' },
          url: [],
        },
      },
      permissions: [
        {
          name: 'content',
          ruleIDs: ['P1', 'P5'],
          isEditable: false,
        },
      ],
    }
  },
  created() {
    // eslint-disable-next-line no-unused-vars
    eventBus.$on('collapse-product-content', text => {
      this.productContentComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  computed: {
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  watch: {
    'productContentComponentModel.model': {
      handler(val) {
        if (val) {
          this.onSubmit()
        }
      },
      deep: true,
    },
    value: {
      handler(val) {
        this.productContentComponentModel = val
        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
  },
  methods: {
    modelChanged() {
      this.productContentComponentModel.isPayloadChanged = true
      this.$emit('input', this.productContentComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        //<SampleComponent :inputData.sync="parentData" />
        // this.$emit('update:isValidateSuccess', this.isValidateSuccess)
        if (result) {
          this.productContentComponentModel.validateState = true
        } else {
          this.productContentComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    addURL() {
      if (!this.productContentComponentModel.model.url) {
        this.productContentComponentModel.model.url = []
      }
      if (
        this.productContentComponentModel.model.url &&
        this.productContentComponentModel.model.url.length < 5
      ) {
        this.productContentComponentModel.model.url.push('')
      }
    },
    checkItem() {
      // eslint-disable-next-line no-console
      console.log('checkItem', this.productContentComponentModel.model.url)
    },
    onRemoveUrl(index) {
      if (
        this.productContentComponentModel.model.url &&
        this.productContentComponentModel.model.url.length > 1
      ) {
        this.productContentComponentModel.model.url.splice(index, 1)
      }
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
  },
}
</script>
